import React from 'react';

interface AlyzeLogoAProps {
  className?: string;
  color?: string;
}

export const AlyzeLogoA: React.FC<AlyzeLogoAProps> = ({ 
  className = '', 
  color = '#444444' 
}) => {
  return (
    <svg 
      width="363" 
      height="365" 
      viewBox="0 0 363 365" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M175.244 78.3358L76.8736 346.76C73.2802 357.65 63.5266 364.932 52.6822 364.932H0L121.727 18.444C125.577 7.35036 135.523 0 146.625 0H216.889C228.054 0 238 7.41842 241.786 18.512L363 365H310.382C299.473 365 289.784 357.718 286.191 346.828L187.756 78.3358C185.703 72.0063 177.297 72.0063 175.244 78.3358Z" 
        fill={color}
      />
    </svg>
  );
};
